export enum SortType {
    TEXT = "text",
    NUMBER = "numeric",
    BOOLEAN = "boolean",
    DATE = "date",
}

